export function isObject(x: any): boolean {
  return Object.prototype.toString.call(x) === '[object Object]';
}

export function createPaths(paths: string[], object: any, prefix: string) {
  let keys = Object.keys(object);
  keys.forEach((key) => {
    if (key !== 'methods') {
      if (isObject(object[key])) {
        paths.push(prefix + '/' + key);
        createPaths(paths, object[key], prefix + '/' + key);
      }
    }
  });
}

export function findPath(object: any, path: string) {
  const keys = path.split('/');
  let temp = object;
  keys.forEach((key: string) => {
    try {
      if (!temp.hasOwnProperty(key)) {
        return undefined;
      }
      temp = temp[key];
    } catch {
      return undefined;
    }
  });
  return temp;
}
